/**
 * The base layout component.
 *
 * This component wraps children in a basic layout consisting of a single
 * vertical flexbox.
 *
 * @param {{ children: React.ReactNode }} props Component props.
 * @prop {React.ReactNode} children The children to be rendered.
 * @returns {JSX.Element} The base layout component.
 */
export const BaseLayout = ({ children }: { children: React.ReactNode }) => (
  <div className="flex flex-col min-h-screen">
    {children}
  </div>
);
